
import { useFilter } from '../../../filter/hook'
import { useQuery } from 'react-query'
import dataAPI from '../../services/dataAPI'
import { getPrevFilter, getNextFilter } from '../../../filter/utils/prefetchFilters'

export default function useVoltageCore() {

  const{filter} = useFilter()
  const prevFilter = getPrevFilter(filter);
  const nextFilter = getNextFilter(filter);

  const voltageQuery = useQuery({
    queryKey: ['voltage-consumption', filter],
    queryFn: () => dataAPI.getVoltageSingleCounter(filter)
})

  const lastVoltageQuery = useQuery({
    queryKey: ['voltage-consumption-last', filter.device_name],
    queryFn: () => dataAPI.getLastVoltageSingleCounter(filter)
  })

  // Préchargement des données pour les fenêtres précédente et suivante
  useQuery({
    queryKey: ['voltage-consumption', prevFilter],
    queryFn: () => dataAPI.getVoltageSingleCounter(prevFilter),
    enabled: !!filter.device_name,
    staleTime: 5 * 60 * 1000,
  });

  useQuery({
    queryKey: ['voltage-consumption', nextFilter],
    queryFn: () => dataAPI.getVoltageSingleCounter(nextFilter),
    enabled: !!filter.device_name,
    staleTime: 5 * 60 * 1000,
  });
  return{
      
      filter,
      lastVoltageQuery:{
        data : lastVoltageQuery.data,
        isLoading : lastVoltageQuery.isLoading,
        isSuccess : lastVoltageQuery.isSuccess,
        isError : lastVoltageQuery.isError,
        error : lastVoltageQuery.error,
        refetch : lastVoltageQuery.refetch,
        isRefetching : lastVoltageQuery.isRefetching
      },
      voltageQuery : {
        data : voltageQuery.data,
        isLoading : voltageQuery.isLoading,
        isSuccess : voltageQuery.isSuccess,
        isError : voltageQuery.isError,
        error : voltageQuery.error,
        refetch : voltageQuery.refetch,
        isRefetching : voltageQuery.isRefetching
      },
  }
}
